import * as React from 'react';
import StepRender from './StepRender';
interface FCProps {}

const Index: React.FC<FCProps> = ({}) => {
  return (
      <StepRender />
  );
};

export default Index;
